import { ReactNode, useEffect, useRef, useState } from 'react';
import * as S from './styles.ts';
import { Popover as Pop } from 'react-tiny-popover';
import { AnimatePresence, motion } from 'framer-motion';

export interface IPopoverProps {
  children: ReactNode;
  tip: any;
  positions?: ('right' | 'left' | 'bottom' | 'top')[];
  padding?: number;
  popoverProps?: any;
  delay?: number;
  visible?: boolean;
}

const Popover = ({
  visible,
  children,
  tip,
  positions,
  padding,
  popoverProps,
  delay = 750,
}: IPopoverProps) => {
  const [mounted, setMounted] = useState(false);
  const [show, setShow] = useState(false);
  const [actualShow, setActualShow] = useState(false);
  const timerRef = useRef<any | null>(null);
  const actualTimerRef = useRef<any | null>(null);

  const handleMouseOver = () => {
    timerRef.current = setTimeout(() => {
      setShow(true);
    }, delay);
  };

  const handleMouseOut = () => {
    setShow(false);
    clearTimeout(timerRef.current);
  };

  const handleMouseDown = () => {
    setShow(false);
    clearTimeout(timerRef.current);
  };

  useEffect(() => {
    if (!show) {
      actualTimerRef.current = setTimeout(() => {
        setActualShow(false);
      }, 750);
    } else {
      setActualShow(true);
    }

    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [show]);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, [mounted]);

  if (!mounted) return;

  return (
    <Pop
      containerStyle={{
        zIndex: '5',
      }}
      align='center'
      padding={padding}
      boundaryInset={10}
      positions={positions || ['right', 'left', 'bottom', 'top']}
      reposition={true}
      transformMode='absolute'
      boundaryElement={document.getElementsByTagName('body')[0] as HTMLElement}
      isOpen={visible || actualShow}
      content={
        <AnimatePresence>
          {(visible || show) && (
            <S.PopoverWrapper
              as={motion.div}
              transition={{
                duration: 0.1,
                type: 'easeOut',
              }}
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: visible || show ? 1 : 0,
              }}
              exit={{
                opacity: 0,
              }}
            >
              <S.PopoverContainer>{tip}</S.PopoverContainer>
              <S.Arrow $position={positions?.[0] || 'right'} />
            </S.PopoverWrapper>
          )}
        </AnimatePresence>
      }
    >
      <S.PopoverOverWrapper
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        {...popoverProps}
      >
        {children}
      </S.PopoverOverWrapper>
    </Pop>
  );
};

export default Popover;
